/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyExternalOrderShipmentItem from './pharmacy-external-order-shipment-item';
import PharmacyExternalOrderShipmentItemDetail from './pharmacy-external-order-shipment-item-detail';
import PharmacyExternalOrderShipmentItemUpdate from './pharmacy-external-order-shipment-item-update';
import PharmacyExternalOrderShipmentItemDeleteDialog from './pharmacy-external-order-shipment-item-delete-dialog';

const PharmacyExternalOrderShipmentItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyExternalOrderShipmentItem />} />
    <Route path="new" element={<PharmacyExternalOrderShipmentItemUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyExternalOrderShipmentItemDetail />} />
      <Route path="edit" element={<PharmacyExternalOrderShipmentItemUpdate />} />
      <Route path="delete" element={<PharmacyExternalOrderShipmentItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyExternalOrderShipmentItemRoutes;
